const PATH_PREFIX = '/admin/company/:companyID/code';

export default [
  {
    name: 'code.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'code.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'code.qr_code',
    path: `${PATH_PREFIX}/qr_code`,
  },
  {
    name: 'code.qr_code_details',
    path: `${PATH_PREFIX}/qr_code/:codeID/details`,
  },
];
